import type { ReactElement } from 'react'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import LogoutIcon from '@mui/icons-material/Logout'
import PersonIcon from '@mui/icons-material/Person'
import { Box, Divider, ListItemIcon, ListSubheader, Menu, MenuItem } from '@mui/material'

const MENU_ITEM_SX = { minHeight: { sm: 44, lg: 'auto' } } as const

export interface AppUserMenuProps {
  anchorEl: HTMLElement | null
  open: boolean
  onClose: () => void
  displayName: string
  username: string
  showAdmin: boolean
  showFeedback: boolean
  onProfile: () => void
  onAdmin: () => void
  onFeedback: () => void
  onLogout: () => void
}

export default function AppUserMenu({
  anchorEl,
  open,
  onClose,
  displayName,
  username,
  showAdmin,
  showFeedback,
  onProfile,
  onAdmin,
  onFeedback,
  onLogout
}: AppUserMenuProps): ReactElement {
  function select(action: () => void) {
    return () => {
      onClose()
      action()
    }
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{ paper: { sx: { width: 240, maxWidth: 'calc(100vw - 32px)' } } }}
    >
      <ListSubheader
        component="div"
        disableSticky
        sx={{ lineHeight: 1.4, pt: 1, pb: 1.25, mb: 0.5, borderBottom: 1, borderColor: 'divider' }}
      >
        <Box
          title={displayName}
          sx={{ color: 'text.primary', fontWeight: 600, fontSize: '0.875rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {displayName}
        </Box>
        {username && (
          <Box
            title={username}
            sx={{ fontSize: '0.75rem', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {username}
          </Box>
        )}
      </ListSubheader>
      <MenuItem sx={MENU_ITEM_SX} onClick={select(onProfile)}>
        <ListItemIcon><PersonIcon fontSize="small" /></ListItemIcon>
        Профиль
      </MenuItem>
      {showAdmin && (
        <MenuItem sx={MENU_ITEM_SX} onClick={select(onAdmin)}>
          <ListItemIcon><AdminPanelSettingsIcon fontSize="small" /></ListItemIcon>
          Админка
        </MenuItem>
      )}
      {showFeedback && (
        <MenuItem sx={MENU_ITEM_SX} onClick={select(onFeedback)}>
          <ListItemIcon><ChatBubbleOutlineIcon fontSize="small" /></ListItemIcon>
          Обратная связь
        </MenuItem>
      )}
      <Divider />
      <MenuItem sx={MENU_ITEM_SX} onClick={select(onLogout)}>
        <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
        Выход
      </MenuItem>
    </Menu>
  )
}
